module.exports = __webpack_public_path__ + "img/picto2.f5d05171.svg";